<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <!-- Top Action Bar -->
    <div class="top-action-bar">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div class="d-flex flex-column align-items-start">
          <div class="page-title">{{ 'viewGalleryProduct.galleryProducts' | transloco }}</div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <div class="search-input-wrapper">
            <i class="fa fa-search search-icon"></i>
            <input type="text" class="form-control search-input" [placeholder]="'viewGalleryProduct.search' | transloco" />
          </div>
          <button type="button" pButton icon="pi pi-plus" [label]="'viewGalleryProduct.createProduct' | transloco"
            class="p-button-outlined p-button-sm" (click)="oncreateGalleryProduct()">
          </button>
        </div>
      </div>
    </div>

    <!-- Skeleton Loader -->
    @if (isLoading) {
      <div class="row my-2">
        @for (placeholder of [1,2,3,4,5,6]; track placeholder) {
          <div class="col-4 mt-3">
            <div class="skeleton-card">
              <div class="skeleton-image"></div>
              <div class="skeleton-details">
                <div class="skeleton-text skeleton-title"></div>
                <div class="skeleton-text skeleton-line"></div>
                <div class="skeleton-text skeleton-line short"></div>
                <div class="skeleton-text skeleton-line"></div>
              </div>
            </div>
          </div>
        }
        <div class="col-12 text-center text-muted small mt-3">
          <i class="pi pi-spin pi-spinner me-2"></i> {{ 'viewGalleryProduct.loadingProducts' | transloco }}
        </div>
      </div>
    }

    @if (!isLoading) {
      <div class="col-12 mt-4">
        @if (GalleryProduct && GalleryProduct.length > 0) {
          <ds-artwork-grid context="gallery-products" #gp class="d-block">
            @for (product of GalleryProduct; track product) {
              <ds-artwork-card
                [size]="gp.size"
                [imageUrl]="product.ProductImgUrl"
                [name]="product.Name"
                [artist]="product.ArtistName"
                [price]="product.CostPrice"
                [priceLabel]="'viewGalleryProduct.costPrice' | transloco"
                (cardClick)="goToArtworkDetails(product)"></ds-artwork-card>
            }
          </ds-artwork-grid>
        }
          <!-- Display "Not Found" message if current inventory data is not available -->
          @if (!(GalleryProduct) || (GalleryProduct.length === 0)) {
            <div class="row my-2">
              <div class="col-6 text-left">
                {{ 'viewGalleryProduct.noDataAvailable' | transloco }}
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>